<template>
    <div class="workbench-container">
        <div class="content-box">
            <div class="title-box">
                <span class="title">{{ detail.name }}</span>
                <span class="status-badge" :class="detail.status_text">{{ detail.status_name }}</span>
            </div>
            <div class="workbench-main">
                <!-- 顶部导航与操作栏 -->
                <div class="header">
                    <div class="header-left">
                        <div class="nav-tabs">
                            <div class="nav-item" v-for="(tab, index) in tabs" :key="index"
                                :class="{ active: currentTab === tab.key }" @click="switchTab(tab.key)">
                                <img class="tab-icon" :src="currentTab === tab.key ? tab.activeIcon : tab.icon"
                                    alt="tab-icon"></img>
                                {{ tab.label }}
                            </div>
                        </div>
                    </div>
                    <button class="action-btn" @click="handleBuyAgain">
                        <img class="action-icon" src="@/assets/images/design/icon-check-correct.png"
                            alt="action-icon" />
                        再次下单同款
                    </button>
                </div>

                <!-- 内容展示区 -->
                <div class="content-area">
                    <keep-alive>
                        <component :is="currentTabComponent" :detail="detail" />
                    </keep-alive>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 引入四个子组件
import StyleInfoTab from './components/StyleInfoTab.vue';
import BomTab from './components/BomTab.vue';
import CraftInfoTab from './components/CraftInfoTab.vue';
import OrderRecordTab from './components/OrderRecordTab.vue';
import { 
    GetDesignByUUID,
} from '@/api/index';

import iconStyleInfo from '@/assets/images/design/ico-style-information.png';
import iconStyleInfoActive from '@/assets/images/design/ico-style-information-active.png';
import iconBom from '@/assets/images/design/icon-material-bom.png';
import iconBomActive from '@/assets/images/design/icon-material-bom-active.png';
import iconProcess from '@/assets/images/design/icon-process-details.png';
import iconProcessActive from '@/assets/images/design/icon-process-details-active.png';
import iconOrderRecord from '@/assets/images/design/icon-sample-record.png';
import iconOrderRecordActive from '@/assets/images/design/icon-sample-record-active.png';

export default {
    name: 'WorkBenchDesignDetail',
    components: {
        StyleInfoTab,
        BomTab,
        CraftInfoTab,
        OrderRecordTab
    },
    data() {
        return {
            currentTab: 'styleInfo', // 默认选中第一个
            tabs: [
                { key: 'styleInfo', label: '款式信息', icon: iconStyleInfo, activeIcon: iconStyleInfoActive },
                { key: 'bom', label: '物料bom', icon: iconBom, activeIcon: iconBomActive },
                { key: 'process', label: '工艺详情', icon: iconProcess, activeIcon: iconProcessActive },
                { key: 'orderRecord', label: '下样记录', icon: iconOrderRecord, activeIcon: iconOrderRecordActive }
            ],
            detail: {},
        };
    },
    computed: {
        currentTabComponent() {
            const map = {
                styleInfo: 'StyleInfoTab',
                bom: 'BomTab',
                process: 'CraftInfoTab', // 图里没给出工艺详情，先复用样式
                orderRecord: 'OrderRecordTab'
            };
            return map[this.currentTab];
        },
        uuid() {
            return this.$route.query.uuid;
        }
    },
    mounted() {
        this.getDesignDetail();
    },
    methods: {
        getDesignDetail() {
            GetDesignByUUID({
                uuid: this.uuid
            }).then(res => {
                console.log(res);
                if (res.code === 0) {
                    this.detail = this.handleData(res.data || {});
                }
            });
        },
        handleData(data) {
            if (data.pattern && data.pattern.length) {
                data.pattern = data.pattern.filter(item => item.name);
            }
            return data;
        },
        switchTab(key) {
            this.currentTab = key;
        },
        handleBuyAgain() {
            console.log('点击了再次下单同款按钮');
            const query = { uuid: this.uuid, from: "design"};
            this.$router.push({
                name: "WorkBenchSummary",
                query,
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.workbench-container {
    background: #f6f7fa;
    padding: 24px 0 150px 0;

    .content-box {
        width: 1200px;
        margin: 0 auto;

        .title-box {
            width: 1200px;
            display: flex;
            align-items: center;

            .title {
                font-weight: bold;
                font-size: 20px;
                color: #0F1115;
                text-align: left;
                font-style: normal;
                text-transform: none;
            }

            .status-badge {
                margin-left: 12px;
                padding: 2px 10px;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #02C160;
                font-weight: 400;
                font-size: 12px;
                color: #02C160;
                text-align: left;
                font-style: normal;
                text-transform: none;
                &.draft {
                    color: #30c6d0;
                    border: 1px solid #30c6d0;
                }
                &.bargain {
                    color: #ff9000;
                    border: 1px solid #ff9000;
                }
                &.confirm_design {
                    color: #02C160;
                    border: 1px solid #02C160;
                }
            }
        }

        .workbench-main {
            width: 1200px;
            margin: 16px auto;
            background: white;
            padding: 20px;
            border-radius: 10px;
            overflow: hidden;

            .header {
                display: flex;
                justify-content: space-between;
                align-items: start;
                border-bottom: 1px solid #d6d6d6;

                .header-left {
                    display: flex;
                    align-items: center;

                    .nav-tabs {
                        display: flex;
                        margin-right: 24px;
                        gap: 48px;

                        .nav-item {
                            display: flex;
                            align-items: center;
                            padding-bottom: 18px;
                            color: #333333;
                            cursor: pointer;
                            font-size: 16px;
                            border-bottom: 3px solid transparent;
                            transition: all 0.3s;

                            .tab-icon {
                                width: 22px;
                                height: 22px;
                                margin-right: 6px;
                            }

                            &.active {
                                border-bottom: 3px solid #FF5967;
                                font-weight: bold;
                            }
                        }
                    }

                }

                .action-btn {
                    background: linear-gradient(90deg, #FF5967 0%, #FF2739 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    padding: 8px 16px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;

                    &:hover {
                        background-color: #ff7875;
                    }

                    .action-icon {
                        width: 18px;
                        height: 18px;
                        margin-right: 6px;
                    }
                }
            }

            .content-area {
                padding: 24px 0;
            }
        }
    }
}
</style>